module.exports = __webpack_public_path__ + "static/proyecto-girha-29a16c408594b799c6c3ce94c4167c2b.png";